import React from "react";
import "./Privacy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h2 className="privacy-title">Политика конфиденциальности</h2>

      <p className="privacy-text">
        Настоящая Политика конфиденциальности регулирует порядок сбора, использования и защиты персональных данных пользователей сайта [Название сайта] (далее — «Сайт»). Мы стремимся обеспечить конфиденциальность и безопасность ваших данных в соответствии с действующим законодательством.
      </p>

      <h3 className="privacy-section">1. Какие данные мы собираем</h3>
      <p className="privacy-text">
        Мы можем собирать следующие данные, которые вы предоставляете добровольно:
      </p>
      <ul className="privacy-list">
        <li>Имя, email и другие контактные данные, указанные при заполнении форм (например, для обратной связи или добавления специалиста);</li>
        <li>Информацию, предоставленную через комментарии, сообщения или пожертвования;</li>
        <li>Технические данные: IP-адрес, тип устройства, браузер, время посещения (собираются автоматически при использовании сайта).</li>
      </ul>

      <h3 className="privacy-section">2. Как мы используем ваши данные</h3>
      <p className="privacy-text">
        Собранные данные используются для:
      </p>
      <ul className="privacy-list">
        <li>Обеспечения работы сайта и предоставления вам информации (например, ответов на запросы);</li>
        <li>Улучшения функциональности сайта и анализа его использования;</li>
        <li>Обработки пожертвований, если вы решите поддержать проект;</li>
        <li>Связь с вами по вопросам, связанным с использованием сайта.</li>
      </ul>

      <h3 className="privacy-section">3. Передача данных третьим лицам</h3>
      <p className="privacy-text">
        Мы не передаём ваши персональные данные третьим лицам, за исключением случаев:
      </p>
      <ul className="privacy-list">
        <li>Когда это необходимо для обработки платежей (например, через платёжные системы);</li>
        <li>Если это требуется по закону или для защиты наших прав;</li>
        <li>С вашего явного согласия.</li>
      </ul>

      <h3 className="privacy-section">4. Как мы защищаем ваши данные</h3>
      <p className="privacy-text">
        Мы принимаем меры для защиты ваших данных от несанкционированного доступа, утраты или изменения, включая использование шифрования и ограничение доступа к информации. Однако ни один способ передачи данных через интернет не может быть гарантированно безопасным на 100%.
      </p>

      <h3 className="privacy-section">5. Ваши права</h3>
      <p className="privacy-text">
        Вы имеете право:
      </p>
      <ul className="privacy-list">
        <li>Запросить доступ к вашим данным, которые мы храним;</li>
        <li>Потребовать исправления или удаления ваших данных;</li>
        <li>Отозвать согласие на обработку данных (если оно было дано).</li>
      </ul>
      <p className="privacy-text">
        Если вы хотите, чтобы ваши данные были удалены, пожалуйста, напишите нам по email:{" "}
        <a href="mailto:omakeykina@gmail.com">omakeykina@gmail.com</a>. Мы обработаем ваш запрос в кратчайшие сроки.
      </p>

      <h3 className="privacy-section">6. Использование cookies</h3>
      <p className="privacy-text">
        Наш сайт использует cookies и аналогичные технологии для улучшения вашего опыта и показа релевантной рекламы.
        Мы используем сертифицированную Google платформу управления согласием для соблюдения требований GDPR.
      </p>
      <p className="privacy-text">
        При первом посещении сайта вы увидите запрос согласия на использование cookies.
        Вы можете изменить свои настройки в любое время.
      </p>

      <h3 className="privacy-section">7. Изменения в политике</h3>
      <p className="privacy-text">
        Мы можем обновлять эту Политику конфиденциальности. Актуальная версия всегда доступна на этой странице. Дата последнего обновления: 9 апреля 2025 года.
      </p>

      <h3 className="privacy-section">8. Контакты</h3>
      <p className="privacy-text">
        Если у вас есть вопросы по поводу этой политики или обработки данных, пишите нам:
      </p>
      <ul className="privacy-list">
        <li>Email: <a href="mailto:omakeykina@gmail.com">omakeykina@gmail.com</a></li>
        <li>Telegram: <a href="https://t.me/Olga_Makey" target="_blank" rel="noopener noreferrer">@Olga_Makey</a></li>
      </ul>

      <div className="privacy-note">
        <p className="privacy-note-text">
          💡 Мы ценим ваше доверие и делаем всё возможное, чтобы ваши данные оставались в безопасности.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;